export default "__VITE_ASSET__COvTRb_K__"